// extracted by mini-css-extract-plugin
module.exports = {"heading":"FolderFeed_heading__1NvOD"};